import * as React from 'react';

function Close() {
  return (
    <svg width={12} height={13} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.645 11.372L7.12 6.846l4.432-4.432a.792.792 0 00-.012-1.12.792.792 0 00-1.12-.011L5.988 5.715 1.463 1.189a.792.792 0 00-1.12-.011.792.792 0 00.012 1.12L4.88 6.822.45 11.254a.792.792 0 00.011 1.12.792.792 0 001.12.012l4.432-4.432 4.525 4.526a.792.792 0 001.12.011.792.792 0 00-.012-1.12z"
        fill="#fff"
      />
    </svg>
  );
}

export default Close;
